import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'

import Heading from '@react/react-spectrum/Heading'

import { RootContext } from '../../root/RootContext'
import { ProfileContext } from '../../root/ProfileContext'
import { getProfileFieldValue } from '../../config/lib.js'

import './ProfileOverview.scss'

export default function ProfileOverview() {
  const rootContext = useContext(RootContext)
  const profileContext = useContext(ProfileContext)
  const tenantId = '_' + rootContext?.project?.integrations?.aep?.imsOrg?.tenantID
  const filters = rootContext?.project?.profileViewer?.segments?.segmentFilter

  const profileFields = rootContext.project.profileViewer.profileFields
  const currentProfile = profileContext.state.currentProfile
  const [filteredList, setFilteredList] = useState([])

  useEffect(() => {
    if (currentProfile && currentProfile.segmentsList) {
      const filteredList = currentProfile.segmentsList.filter((segmentId) => {
        if (Array.isArray(filters) && filters.length > 0 && segmentId[1].name) {
          return filters.reduce((acc, it) => acc || segmentId[1].name.includes(it), false)
        } else {
          return true
        }
      })
      setFilteredList(filteredList)
    }
  }, [currentProfile])

  return (
    <div className='profile-overview'>
      <div className='scroll-wrapper'>
        {currentProfile &&
          currentProfile.profile &&
          profileFields.map((field) => {
            if (!field.path) {
              return null
            }

            return (
              <div className='profile-field' key={`profile-${field.label}`}>
                <Heading variant='subtitle3' className='field-label'>
                  {field.label}
                </Heading>
                <div className='field-value'>{getProfileFieldValue(tenantId, currentProfile, field.path)}</div>
              </div>
            )
          })}

        {currentProfile && currentProfile.profile && currentProfile.segmentsList && (
          <div className='segment-overview'>
            <Heading
              variant='subtitle1'
              style={{
                backgroundColor: rootContext.project.branding.backgroundColor,
                color: rootContext.project.branding.primaryTextColor,
                fontFamily: rootContext.project.branding.bodyFont,
              }}
            >
              Segments
            </Heading>
            {filteredList !== '' &&
              filteredList.map((segmentId) => (
                <div key={`segment-${segmentId[1].id}`} className='product-segment-info'>
                  <div className='segment-name-fields'>
                    <div className='timestamp'>
                      {new Date(segmentId[1].lastQualificationTime).toLocaleString([], {
                        dateStyle: 'medium',
                        timeStyle: 'short',
                      })}
                    </div>
                    <div className='field-value'>{segmentId[1].name}</div>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  )
}

ProfileOverview.requiresLaunch = true
